// extracted by mini-css-extract-plugin
export default {"upfrontWrapper":"PlanCard_upfrontWrapper__YGLz2","upfrontCopy":"PlanCard_upfrontCopy__GgN9M","pricingContainerHeading":"PlanCard_pricingContainerHeading__EzIOK"};